import React, { Component } from "react"

export default class TOCsb extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Tools of Relation</p>
            <p className="portdesctext">Developed & Designed app commissioned by Lila Bullen-Smith & Naira Nigrelli to map Rivelt Academy staff network. App designed in PyQt5 with MongoDB database.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://www.dropbox.com/s/f0uczmazf96xvvx/sb_final_project.pdf?dl=0" target="_blank" rel="noopener noreferrer"><p className="linktext">PDF</p></a>
        </div>
      </div>
  )
}
}

